// Small wrapper over THREE.InstancedMesh for static repeated scenery
// (windows, vegetation, clutter). Fill once, then shift whole-set z for the
// scrolling world via per-frame matrix updates on a parent group instead —
// so instances are placed in LOCAL space and the set is added to a group.

import * as THREE from 'three';

export class InstancedSet {
  readonly mesh: THREE.InstancedMesh;
  private count = 0;
  private readonly dummy = new THREE.Object3D();

  constructor(geometry: THREE.BufferGeometry, material: THREE.Material, capacity: number) {
    this.mesh = new THREE.InstancedMesh(geometry, material, capacity);
    this.mesh.count = 0;
    this.mesh.instanceMatrix.setUsage(THREE.StaticDrawUsage);
    this.mesh.castShadow = false;
    this.mesh.receiveShadow = false;
  }

  add(x: number, y: number, z: number, scale = 1, rotY = 0, scaleY?: number): void {
    if (this.count >= this.mesh.instanceMatrix.count) return; // Capacity guard
    this.dummy.position.set(x, y, z);
    this.dummy.rotation.set(0, rotY, 0);
    this.dummy.scale.set(scale, scaleY ?? scale, scale);
    this.dummy.updateMatrix();
    this.mesh.setMatrixAt(this.count, this.dummy.matrix);
    this.count++;
    this.mesh.count = this.count;
    this.mesh.instanceMatrix.needsUpdate = true;
  }

  setColorAt(index: number, color: THREE.Color): void {
    this.mesh.setColorAt(index, color);
    if (this.mesh.instanceColor) this.mesh.instanceColor.needsUpdate = true;
  }

  get instanceCount(): number {
    return this.count;
  }
}
